export default "__VITE_ASSET__5f74b1f8__"